<template functional>
  <div
    class="dataset-cell-tag-status tag"
    v-bind="data.attrs"
    :class="[data.staticClass, props.class]"
    :style="{
      backgroundColor: props.addons.status_color,
      color: $options.getColor(props)
    }"
  >
    {{ props.value }}
  </div>
</template>

<script>
import ModuleBase from './module-base'

export default {
  name: 'DatasetCellTagStatus',
  mixins: [ModuleBase],
  getColor: props => {
    // const v = props.addons.status_color
    // return findInvertColor(v, true)
    return 'white'
  },
}
</script>
